// extracted by mini-css-extract-plugin
module.exports = {"container":"ContextMenuArea_container__2_f5U","menuPaper":"ContextMenuArea_menuPaper__3EAeg","menuItem":"ContextMenuArea_menuItem__pSEaV"};